export const NDW_COLOR_MAIN = '#FF5100';
export const NDW_COLOR_SECONDARY = '#F98A3C';
